module.exports = __webpack_public_path__ + "img/hand-sign.ab499632.png";